module.exports = __webpack_public_path__ + "img/622.0a4b6f5e.png";